import { MaskProps } from "./types"
import { MaskCore } from "./core"
import React from "react"

const Mask: React.FC<MaskProps> = (props) => {
  return <MaskCore {...props}></MaskCore>
}

export default Mask
